import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { SystemTypeEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { ValueReferenceTypeEnum } from 'src/app/domain/registration/enums/value-reference-type.enum';
import { PartnerIndexMultiSelectComponent } from '../partners/crud-index/crud-index-multiselect.component';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';

export const RELATIVE_URL = 'plans';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'system',
  'terminalQuantity',
  'monthlyValue',
  'adhesionFee',
  'isDaysCount',
  'type',
  'dueDate',
  'createdAt',
  'hasPartners',
  'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.IMAGE,
    link_show: true,
    property: 'image',
    display: 'SOLUÇÃO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size responsive-column`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'partners',
    display: 'PARCEIROS',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },

  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'hasPartners',
    display: 'PARCEIROS VINCULADOS',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'system',
    display: 'SISTEMA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'terminalQuantity',
    display: 'QTD TERMINAL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'monthlyValue',
    display: 'VALOR MENSALIDADE',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'referenceValue',
    display: 'VALOR DE REFERENCIA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'percentage',
    display: 'REFERENCIA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_CURRENCY,
    link_show: true,
    property: 'adhesionFee',
    display: 'TAXA DE ADESÃO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'isDaysCount',
    display: 'DIAS CORRIDOS',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'selectReference',
    display: 'VALOR DE REFERENCIA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_DATE_TIME,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'dueDate',
    display: 'DATA DE VENCIMENTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'planDescription',
    display: 'DESCRIÇÃO DO ARQUIVO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  }
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'PARCEIRO',
    component: PartnerIndexMultiSelectComponent,
    name: 'partners',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Sistema',
    component: SystemIndexSelectComponent,
    componentData: {
      // Simplificacao: modal de sistema lista TODAS as solucoes (sem filtro por tipo).
      params: {},
    },
    name: 'system',
    value: 'name',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'QTD TERMINAL *',
    name: 'terminalQuantity',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'DATA DE VENCIMENTO',
    name: 'dueDate',
    defaultValue: '10',
    validators: [Validators.required],
    disabled: true
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'VALOR MENSALIDADE',
    name: 'monthlyValue',
    defaultValue: '0',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'VALOR DE REFERENCIA',
    name: 'referenceValue',
    defaultValue: '0',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'REFERENCIA',
    name: 'percentage',
    options: Object.values(ValueReferenceTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_CURRENCY,
    label: 'TAXA DE ADESÃO',
    name: 'adhesionFee',
    defaultValue: '0',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'DIAS CORRIDOS',
    name: 'isDaysCount',
    value: true,
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'UTILIZAR REFERENCIA',
    name: 'selectReference',
    value: true,
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'COMISSÃO UNIDADE',
    name: 'isUnitCommission',
    value: false,
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'DESCRIÇÃO DO ARQUIVO',
    name: 'planDescription',
    validators: [Validators.required],
  }
];
